import { render, staticRenderFns } from "./AdminNotificationStatus.vue?vue&type=template&id=5b92bd86"
import script from "./AdminNotificationStatus.vue?vue&type=script&lang=js"
export * from "./AdminNotificationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports